import { useLocation as useReactRouterLocation } from "react-router-dom";

const PREFIX = "/jainboarding-admin";

/**
 * Custom location hook that removes the /jainboarding-admin prefix from the pathname
 * so components can work with relative paths
 */
export const usePrefixedLocation = () => {
  const location = useReactRouterLocation();

  return {
    ...location,
    pathname: location.pathname.startsWith(PREFIX)
      ? location.pathname.slice(PREFIX.length) || "/"
      : location.pathname,
  };
};
